export const avatarList = {
    "琴": "Jean",
    "旅行者": "Traveler",
    "丽莎": "Lisa",
    "芭芭拉": "Barbara",
    "凯亚": "Kaeya",
    "迪卢克": "Diluc",
    "雷泽": "Razor",
    "安柏": "Amber",
    "温迪": "Venti",
    "香菱": "Xiangling",
    "北斗": "Beidou",
    "行秋": "Xingqiu",
    "凝光": "Ningguang",
    "可莉": "Klee",
    "菲谢尔": "Fischl",
    "班尼特": "Bennett",
    "达达利亚": "Tartaglia",
    "诺艾尔": "Noelle",
    "重云": "Chongyun",
    "迪奥娜": "Diona",
    "莫娜": "Mona",
    "刻晴": "Keqing",
    "砂糖": "Sucrose",
    "七七": "Qiqi",
    "阿贝多": "Albedo",
    "埃洛伊": "Aloy",
    "优菈": "Eula",
    "甘雨": "Ganyu",
    "胡桃": "Hutao",
    "枫原万叶": "Kaedehara Kazuha",
    "神里绫华": "Kamisato Ayaka",
    "九条裟罗": "Kujou Sara",
    "雷电将军": "Raiden Shogun",
    "罗莎莉亚": "Rosaria",
    "珊瑚宫心海": "Sangonomiya Kokomi",
    "早柚": "Sayu",
    "魈": "Xiao",
    "辛焱": "Xinyan",
    "烟绯": "Yanfei",
    "宵宫": "Yoimiya",
    "钟离": "Zhongli",
        
}